export default __webpack_public_path__ + "static/media/OQN.631fe207.pdf";